module.exports = __webpack_public_path__ + "static/HSBC_FRA22_Winners-ad63156b650d637fc6edbcb9d1c7ad8f.jpg";